var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFooterShape = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1723 583"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#footer-shape_svg__a)",
  d: "M-218.779 442.442C-244.415 172.097 3.58-45.649 275.174 8.739L1391.48 232.285c325.62 65.207 443.69 461.052 205.03 687.397L591.772 1872.61c-249.146 236.29-666.899 84.67-698.986-253.7z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "footer-shape_svg__a",
  x1: -635.706,
  x2: 1193.77,
  y1: -555.07,
  y2: 1477.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2A0E53"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467,
  stopColor: "#9233CB",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.696,
  stopColor: "#BF56DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#BF56DE",
  stopOpacity: 0.65
})))));
export default SvgFooterShape;